window.onload = function () {

  if (window.location.pathname.includes('webinars')) {

    const bloggers = require("./../includes/youtube-modal"),
      mustache = require('mustache'),
      data = require("./data"),
      mainSwitch = {
        init: function (target, activeClass) {
          this.data = {
            mainSwitchBlock: target,
            children: Array.prototype.slice.call(target.children),
            active: activeClass,
            queryParams: new URL(window.location.href).searchParams
          };
          this.checkLicense();
          this.listener();
          this.closingHandle();
          this.escClickHandler()
          customModal.init('js-modalPricing');
          this.urlParams = new URL(window.location.href).searchParams;
          this.waMode = this.urlParams.get("wa");

          if (this.waMode) {
            document.getElementById('home').style.paddingTop = '20px';
            document.querySelector('html').classList.add('waMode');
            try {
              this.waResizeHandle(window.parent);
              this.handleWaFirstScroll(window.parent);
            } catch {
              this.waResizeHandle(window);
              this.handleWaFirstScroll(window);
            }
          }
          this.defaultView();
          this.courseView();
          this.handleZhCourses();
        },
        handleZhCourses: function () {
          if (localStorage.getItem('langName') === 'zh' && this.waMode) {
            if (!!document.getElementById('cn-webinars')) {
              document.getElementById('cn-webinars').style.display = 'block';
            }
          }
        },
        handleWaFirstScroll: function (target) {
          const firstScrollEvent = () => {
            log("FIRST SCROLL");
            this.waMessage();
            target.removeEventListener('scroll', firstScrollEvent);
          }
          target.addEventListener('scroll', firstScrollEvent);
        },
        checkLicense: function () {
          fetch(`${$AUTH_HOST}/v1/licences/software?state=ACTIVE`, {
            headers: {
              'Accept': 'application/json'
            },
            method: 'GET'
          })
            .then(res => res.json())
            .then(body => {
              if (body.length > 0) {
                const filter = body.filter(e => {
                  if ((e.software === "WEB" || e.software === "SCOUT_EXT_PRO") && !e.trial) {
                    return e;
                  }
                });
                log(filter, 'Active Licenses:')
                if (!filter.length > 0) {
                  this.blockPaidContent();
                }
              } else {
                this.blockPaidContent();
                log(body.message, 'Licenses:');
              }
            }).then(() => {
            this.queryOpen();
            this.updateUrl('js-firstList', true);
            this.updateUrl('js-secondList', true);
            this.updateUrl('js-thirdList', false);
            this.updateUrl('js-fourthList', true);
          })
            .catch(() => {
              this.blockPaidContent();
            });
        },
        blockPaidContent: function () {
          document.querySelectorAll('[data-content="paid"]').forEach(e => {
            const collect = [];
            const recursy = (element) => {
              element.childNodes.forEach(node => {
                if (node.tagName === "A") {
                  collect.push(node);
                } else if (node.tagName === "BUTTON" && node.dataset.block) {
                  node.textContent = node.dataset.block;
                } else {
                  recursy(node);
                }
              });
            }
            recursy(e);
            ["data-target", "data-toggle", "data-toggle", "data-mlink", "data-query-open"].forEach(data => {
              e.removeAttribute(data);
            });
            if (collect.length > 0) {
              collect.forEach(a => {
                a.textContent = "Select a plan to get full access to the Extended course!";
                a.href = "";
                a.style.filter = "blur(5px)";
              })
            }
            e.addEventListener("click", () => {
              if (this.waMode) {
                this.waMessage(false, 'openPaywall');
                log('Wa Paywall');
              } else {
                customModal.view(true);
              }
            });
          });
          document.getElementById('js-webinars-plan').style.display = 'flex';
          document.getElementById('js-webinars-plan-oa').style.display = 'flex';
        },
        queryOpen: function () {
          const open = this.data.queryParams.get("open");

          if (open) {
            try {
              document.querySelector(`[data-query-open="${open}"]`).click();
            } catch {
              log('Undefined target', 'queryOpen:');
            }
          }
        },
        listener: function () {
          this.data.mainSwitchBlock.addEventListener('click', (e) => {
            if (e.target.tagName === 'BUTTON') {
              this.handleClick(e);
              this.switchView(e.target);
            }
          });
        },
        handleClick: function (e) {
          this.removeActive();
          university.reset();
          e.target.classList.add(this.data.active);
        },
        waMessage: function (url, event) {
          if (this.waMode) {
            const height = document.body.offsetHeight,
              checkView = (id) => {
                return document.getElementById(id).style.display !== 'none';
              },
              data = {
                courseHeight: checkView('js-firstList') ? height : null,
                masterHeight: checkView('js-secondList') ? height : null,
                universityHeight: checkView('js-thirdList') ? height : null,
                courseOAHeight: checkView('js-fourthList') ? height : null,
                url: url ? url : null,
                event: event ? event : null
              }
            window.parent.postMessage(data, "*");
            log(data);
          }
        },
        updateUrl: function (id, searchStatus) {
          document.getElementById(id).addEventListener('click', e => {
            if (e.target.tagName !== 'A') {
              const target = e.target,
                nodes = searchStatus ? [target, target.parentNode.parentNode, target.parentNode.parentNode.parentNode] : [target, target.parentNode];
              nodes.forEach(t => {
                try {
                  if (this.waMode && t.dataset.mlink) {
                    e.preventDefault();
                    e.stopPropagation();
                    bloggers.clear();
                    this.waMessage(t.dataset.mlink);
                    log('Wa Modal');
                  } else {
                    const par = t.dataset.queryOpen;
                    if (par) {
                      const queryParams = new URLSearchParams(window.location.search);
                      queryParams.set("open", par);
                      history.replaceState(null, null, "?" + queryParams.toString());
                    }
                  }
                } catch (e) {
                  return true;
                }
              });
            } else {
              e.preventDefault();
              e.stopPropagation();
              const link = e.target.href;
              link !== document.location.href && window.open(link, '_blank');
            }
          });
        },
        removeActive: function () {
          this.data.children.forEach(b => {
            b.classList.remove(this.data.active);
          });
        },
        defaultView: function () {
          const defaultList = this.data.queryParams.get('default'),
            init = this.data.mainSwitchBlock.dataset.switchInit;

          try {
            this.display(`js-${defaultList}List`, true);
            this.display(`js-${defaultList}Title`, true);

            if (defaultList === 'second') {
              this.removeActive();
              this.data.children[2].classList.add(this.data.active);
            } else if (defaultList === 'third') {
              this.removeActive();
              this.data.children[3].classList.add(this.data.active);
            } else if (defaultList === 'fourth') {
              this.removeActive();
              this.data.children[1].classList.add(this.data.active);
            }

            this.display(`js-${init}List`, false);
            this.display(`js-${init}Title`, false);

          } catch {
            this.display(`js-${init}List`, true);
            this.display(`js-${init}Title`, true);
          }
          setTimeout(() => mainSwitch.waMessage(), 1000);
        },
        defaultSelect: function () {
          this.removeActive();
          this.data.children[0].classList.add(this.data.active);
        },
        courseView: function () {
          const currentCourse = this.data.queryParams.get('course');

          if (currentCourse) {
            const index = data.university.courses.findIndex(e => e.url === currentCourse);

            if (index >= 0) {
              university.descriptionRender(data.university, index);
              this.switchView(document.getElementById('js-webswitch').children[3]);
            }
          }
        },
        switchView: function (t) {
          t.dataset.switchOf.split(',').forEach(e => {
            this.display(e, false);
          });
          t.dataset.switchOn.split(',').forEach(e => {
            this.display(e, true);
          });
          this.addQuery(t.dataset.query)
          this.waMessage();
          if (!document.getElementById('js_universitybread').classList.contains('webinars-intro-switch__radio_active')) {
            this.removeQuery('course');
          }
        },
        display: function (target, status) {
          document.getElementById(target).style.display = status ? "block" : "none";
        },
        closingHandle: function () {
          document.querySelector('.close').addEventListener('click', () => {
            this.removeQuery('open');
          });
        },
        escClickHandler: function () {
          document.addEventListener('keydown', (e) => {
            if (e.keyCode === 27) {
              bloggers.clear();
              this.removeQuery('open');
            }
          });
        },
        waResizeHandle: function (target) {
          let currentWidth = null;
          target.addEventListener('resize', e => {
            if (currentWidth !== e.target.innerWidth) {
              currentWidth = e.target.innerWidth;
              this.waMessage();
            }
          });
        },
        removeQuery: function (par) {
          const queryParams = new URLSearchParams(window.location.search);
          queryParams.delete(par);
          history.replaceState(null, null, "?" + queryParams.toString());
        },
        addQuery: function (query) {
          if (query) {
            const queryParams = new URLSearchParams(window.location.search);
            queryParams.set("default", query);
            history.replaceState(null, null, "?" + queryParams.toString());
          } else {
            this.removeQuery('default')
          }
        },
      },
      masterClassSwitch = {
        init: function () {
          this.block = document.getElementById('js-webinars__controller');
          this.waTimer = null;
          this.content = ['js-webinars-content_paid', 'js-webinars-content_free', 'js-webinars-select_free', 'js-webinars-select_paid'];
          if (this.block) {
            this.updateView();
            this.updateView();
            this.handleClick();
          }
        },
        updateView: function () {
          this.active = this.block.querySelector('.contentActive');
          const type = this.active.dataset.select,
            typeStyle = type === 'paid' ? 'flex' : 'block';
          this.content.forEach(e => {
            this.display(e, '');
          });
          this.display(`js-webinars-content_${type}`, typeStyle);
          this.display(`js-webinars-select_${type}`, 'flex');
        },
        display: function (id, display) {
          document.getElementById(id).style.display = display
        },
        handleClick: function () {
          this.block.addEventListener('click', e => {
            if (e.target.tagName === 'BUTTON' || e.target.parentNode === 'BUTTON') {
              Array.prototype.slice.call(this.block.children).forEach(b => {
                b.classList.remove('contentActive');
              });
              e.target.classList.toggle('contentActive');
              this.updateView();
            }
          });
        }
      },
      university = {
        init: function () {
          this.handleClick();
          this.listRender(data.university);
          this.handleClickShowMore()
          // this.handleMobileView();
        },
        handleClick: function () {
          document.getElementById('js-thirdList').addEventListener('click', event => {
            this.descriptionRender(data.university, event.target.dataset.get);
            if (mainSwitch.waMode) {
              window.clearTimeout(this.waTimer);
              this.waTimer = setTimeout(() => {
                this.handleScroll(event);
              }, 500);
            } else {
              this.handleScroll(event);
            }
          });
        },
        switch: function () {
          document.getElementById('js_university-list').style.display = 'none';
          document.getElementById('js_university-description-render').style.display = 'block';
          mainSwitch.waMessage();
        },
        reset: function () {
          if (document.getElementById('js_university-description-render').style.display === 'block') {
            document.getElementById('js_university-list').style.display = 'block';
            document.getElementById('js_university-description-render').style.display = 'none';
            mainSwitch.waMessage();
          }
        },
        descriptionRender: function (data, select) {
          const courseItem = data.courses[select];

          if (courseItem) {
            const target = document.getElementById('university-description-template'),
              template = target.innerHTML,
              html = mustache.render(template, courseItem);
            document.getElementById('js_university-description-render').innerHTML = html;
            this.breadRender(courseItem);
            this.switch();
            this.updateUrl(courseItem.url);
            if (!mainSwitch.waMode) {
              window.scrollTo(0, 0);
            }
            this.handleClickShowMore()
          }
        },
        updateUrl: function (par) {
          mainSwitch.removeQuery('default');
          const queryParams = new URLSearchParams(window.location.search);
          queryParams.set("course", par);
          history.replaceState(null, null, "?" + queryParams.toString());
        },
        breadRender: function ({course}) {
          const elemBread = document.getElementById('js_universitybread');
          const elemText = elemBread.querySelector('span');
          mainSwitch.removeActive();
          elemBread.classList.add('webinars-intro-switch__radio_active');
          elemText.innerText = course.title;
        },
        listRender: function (data) {
          const target = document.getElementById('university-list-template'),
            template = target.innerHTML,
            html = mustache.render(template, data);
          document.getElementById('js_university-list-render').innerHTML = html;
        },
        blockMobile: function () {
          const universityList = document.getElementById('js_universitylist');

          if (window.innerWidth < 1050 && !mainSwitch.waMode) {
            mainSwitch.switchView(document.getElementById('js-webswitch').children[0]);
            mainSwitch.defaultSelect();
            universityList.style.display = 'none';
          } else {
            universityList.style.display = '';
          }
        },
        handleMobileView: function () {
          this.blockMobile();
          window.addEventListener('resize', () => {
            this.blockMobile();
          });
        },
        handleScroll: function (e) {
          if (e.target && e.target.dataset.scroll) {
            const target = document.getElementById(e.target.dataset.scroll);

            if (mainSwitch.waMode) {
              target.scrollIntoView({ behavior: 'smooth' });
            } else {
              const topOfElement = target.offsetTop - 90;
              window.scroll({ top: topOfElement, behavior: "smooth" });
            }
          }
        },
        handleClickShowMore: function () {
          const btns = document.getElementsByClassName('webinars-video__btn_showMore')
          for (let i = 0; i < btns.length; i++) {
            btns[i].addEventListener('click', () => {
              btns[i].parentElement.style.display = 'none'
              btns[i].parentElement.nextElementSibling.style.display = 'block'
            })
          }
        }
      };

    bloggers.init('js-firstList', true);
    bloggers.init('js-secondList', true);
    bloggers.init('js-thirdList', false);
    bloggers.init('js-fourthList', true);
    mainSwitch.init(document.getElementById('js-webswitch'), 'webinars-intro-switch__radio_active');
    masterClassSwitch.init();
    university.init();
    document.querySelector('.newFooterVer2').classList.remove('newFooterVer2_hidden');
  }
}
